export default "__VITE_ASSET__b7ca586c__"